
const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-map-pin-user-line',
      title: 'Ancrage Local',
      description: 'Nous croyons en la force des territoires et en l\'importance de valoriser les ressources locales pour créer un écosystème économique durable et solidaire.',
    },
    {
      icon: 'ri-team-line',
      title: 'Écoute & Échange',
      description: 'Notre démarche est centrée sur l\'écoute active des besoins réels. Nous facilitons les échanges entre acteurs locaux pour créer des synergies bénéfiques à tous.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Solutions Adaptées',
      description: 'Chaque agglomération est unique. Nous proposons des solutions sur mesure qui répondent aux enjeux spécifiques de votre territoire et de votre activité.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Valeurs
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Les principes qui guident notre action au quotidien
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 md:p-10 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-5 md:mb-6">
                <i className={`${value.icon} text-3xl md:text-4xl text-primary`}></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-primary-dark mb-3 md:mb-4">
                {value.title}
              </h3>
              <p className="text-sm md:text-base text-gray-dark leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
